'use client'

import {
  LuArrowRight,
  LuCalendarDays,
  LuChartColumnIncreasing,
  LuChartNoAxesCombined,
  LuChartPie,
  LuChevronRight,
  LuCircleDollarSign,
  LuHouse,
  LuShoppingBag,
  LuSmartphone,
  LuSquarePen,
} from 'react-icons/lu'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '@ui/components/shadcn/ui'

import { useDownloadAppAnalytics } from '@web-app/components/layout/SidebarAppLayout/analytics'

export const NavMain = () => {
  const pathname = usePathname()
  const { trackTap } = useDownloadAppAnalytics()

  return (
    <SidebarGroup>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton isActive={pathname === '/dashboard'} asChild>
            <Link href="/dashboard">
              <LuHouse />
              <span>Home</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
        <Collapsible
          asChild
          defaultOpen={pathname.includes('personal-finance')}
          className="group/collapsible"
        >
          <SidebarMenuItem>
            <CollapsibleTrigger asChild>
              <SidebarMenuButton>
                <LuChartColumnIncreasing />
                <span>Personal Finance</span>
                <LuChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
              </SidebarMenuButton>
            </CollapsibleTrigger>
            <CollapsibleContent>
              <SidebarMenuSub>
                <SidebarMenuSubItem>
                  <SidebarMenuSubButton
                    isActive={pathname === '/dashboard/personal-finance'}
                    asChild
                  >
                    <Link href="/dashboard/personal-finance">
                      <LuChartNoAxesCombined />
                      <span>Dashboard</span>
                    </Link>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>
              </SidebarMenuSub>
              <SidebarMenuSub>
                <SidebarMenuSubItem>
                  {/* TODO: add active logic */}
                  <SidebarMenuSubButton
                    isActive={
                      pathname === '/dashboard/personal-finance/budgets'
                    }
                    asChild
                  >
                    <Link href="/dashboard/personal-finance/budgets">
                      <LuChartPie />
                      <span>Budgets</span>
                    </Link>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>
              </SidebarMenuSub>
              <SidebarMenuSub>
                <SidebarMenuSubItem>
                  <SidebarMenuSubButton
                    isActive={
                      pathname === '/dashboard/personal-finance/recurring'
                    }
                    asChild
                  >
                    <Link href="/dashboard/personal-finance/recurring">
                      <LuCalendarDays />
                      <span>Recurring</span>
                    </Link>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>
              </SidebarMenuSub>
            </CollapsibleContent>
          </SidebarMenuItem>
        </Collapsible>
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={pathname === '/dashboard/offers'}
            asChild
          >
            <Link href="/dashboard/offers">
              <LuShoppingBag />
              <span>Offers</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={pathname === '/dashboard/surveys'}
            asChild
          >
            <Link href="/dashboard/surveys">
              <LuSquarePen />
              <span>Surveys</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={pathname === '/dashboard/cash-advance'}
            asChild
          >
            <Link href="/dashboard/cash-advance">
              <LuCircleDollarSign />
              <span>Cash Advance</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
        <SidebarMenuItem className="mt-2">
          <SidebarMenuButton
            isActive={pathname === '/dashboard/download'}
            asChild
            className="text-primary-foreground hover:text-primary-foreground active:text-primary-foreground data-[active=true]:text-primary-foreground motion-safe:animate-bg-slide bg-[linear-gradient(90deg,hsl(var(--primary)),hsl(var(--secondary)),hsl(var(--primary)))] bg-[length:200%_100%] font-bold shadow-sm hover:brightness-110 data-[active=true]:font-bold"
          >
            <Link
              href="/dashboard/download"
              onClick={() => trackTap('sidebar')}
            >
              <LuSmartphone />
              <span>Download ATM App</span>
              <LuArrowRight className="ml-auto" />
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  )
}
